import { useState } from 'react'
import { Container } from 'react-bootstrap'
import ResizableEtage from 'components/Etage/Etage'
import { ReactComponent as ToitMaison } from 'assets/default/svg/toitmaison.svg'
import { updateEtages } from 'redux/features/bienAVendre/slice'
import { percentToPixel } from 'utils/calculatorHelpers'
import { useAppDispatch } from 'redux/hooks'
import classNames from 'classnames'
import Etage from 'interfaces/Etage'
import BarHandle from './components/BarHandle'
import styles from './Resize.module.scss'

interface Props {
  className?: string
  etages: Etage[]
  setEtages: (newEtages: Etage[]) => void
}

const defaultProps: Partial<Props> = {
  className: undefined,
}

export const ETAGE_MAX_WIDTH = 250 // px

const Resize = (props: Props): JSX.Element => {
  const { className, etages, setEtages } = props
  const [clickHandleOnce, setClickHandleOnce] = useState(false)
  const dispatch = useAppDispatch()

  const widthMaison =
    etages.length > 0
      ? percentToPixel(etages[0].width) // convertion de la width pixel-pourcentage
      : ETAGE_MAX_WIDTH

  const marginMaison = etages.length > 0 ? etages[0].position.x : 0

  const handleOnResize = (currentEtage: Etage, etageIndex: number) => {
    setEtages(
      etages.map((etage, idx) => {
        let newEtage = etage
        // Set the current etage
        if (idx === etageIndex) {
          newEtage = currentEtage
        }

        // Adapt upper floor width and position from current etage
        if (idx < etageIndex) {
          newEtage = {
            ...newEtage,
            width:
              etage.width > currentEtage.width
                ? currentEtage.width
                : etage.width,
            position: {
              ...newEtage.position,
              x:
                currentEtage.position.x > etage.position.x
                  ? currentEtage.position.x
                  : etage.position.x,
            },
          }

          // Resize from left
          const etageWidth = percentToPixel(newEtage.width)
          const currentWidth = percentToPixel(currentEtage.width)
          if (
            etageWidth + newEtage.position.x >
            currentWidth + currentEtage.position.x
          ) {
            newEtage = {
              ...newEtage,
              position: {
                ...newEtage.position,
                x:
                  newEtage.position.x -
                  (etageWidth +
                    newEtage.position.x -
                    (currentWidth + currentEtage.position.x)),
              },
            }
          }
        }

        return newEtage
      })
    )
  }

  const handleOnReiszeStop = () => {
    dispatch(updateEtages(etages))
  }

  return (
    <Container
      className={classNames(className, styles.resize)}
      style={{
        width: ETAGE_MAX_WIDTH,
      }}
    >
      <ToitMaison
        style={{
          width: widthMaison,
          marginLeft: marginMaison,
        }}
      />
      {etages.map((etage, idx) => (
        <ResizableEtage
          key={`etage-${idx}`}
          className={`etage-${idx}`}
          bounds={idx < etages.length - 1 ? `.etage-${idx + 1}` : 'parent'}
          etage={etage}
          onResize={(singleEtage: Etage) => handleOnResize(singleEtage, idx)}
          onResizeStop={handleOnReiszeStop}
          resizeHandleComponent={
            (!clickHandleOnce && {
              left: (
                <BarHandle
                  onMouseDown={() => setClickHandleOnce(true)}
                  variant="left"
                />
              ),
              right: (
                <BarHandle
                  onMouseDown={() => setClickHandleOnce(true)}
                  variant="right"
                />
              ),
            }) ||
            undefined
          }
        />
      ))}
      <Container className={styles.houseBase}>100%</Container>
    </Container>
  )
}

Resize.defaultProps = defaultProps
export default Resize
